module.exports = __webpack_public_path__ + "img/ic-clock-line.2dc1ecb6.svg";